module.exports = __webpack_public_path__ + "img/privitak.99774a19.svg";